
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
  Button,
  TableContainer,
  Table,
  TableRow,
  TableCell,
  TableHead,
  TableBody,
  Paper,
  makeStyles, Container
} from '@material-ui/core';
import { t } from '../common/LocalizationProvider';
import { formatDate } from '../common/formatter';
import ReportLayoutPage from '../reports/ReportLayoutPage';
import { statisticsActions } from '../store';
import moment from 'moment';
import {cyberStyles} from "../cssShared/cyberTheme";
import CssBaseline from "@material-ui/core/CssBaseline";

const useStyles = makeStyles(theme => ({
  ...cyberStyles(theme),
  // Additional local tweaks for the filter section
  filterWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
    padding: theme.spacing(2, 0),
  }
}));

const Filter = () => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const [period, setPeriod] = useState('today');
  const [from, setFrom] = useState(moment().subtract(1, 'hour'));
  const [to, setTo] = useState(moment());

  const handleClick = async () => {
    let selectedFrom;
    let selectedTo;
    switch (period) {
      case 'today':
        selectedFrom = moment().startOf('day');
        selectedTo = moment().endOf('day');
        break;
      case 'yesterday':
        selectedFrom = moment().subtract(1, 'day').startOf('day');
        selectedTo = moment().subtract(1, 'day').endOf('day');
        break;
      case 'thisWeek':
        selectedFrom = moment().startOf('week');
        selectedTo = moment().endOf('week');
        break;
      case 'previousWeek':
        selectedFrom = moment().subtract(1, 'week').startOf('week');
        selectedTo = moment().subtract(1, 'week').endOf('week');
        break;
      case 'thisMonth':
        selectedFrom = moment().startOf('month');
        selectedTo = moment().endOf('month');
        break;
      case 'previousMonth':
        selectedFrom = moment().subtract(1, 'month').startOf('month');
        selectedTo = moment().subtract(1, 'month').endOf('month');
        break;
      default:
        selectedFrom = from;
        selectedTo = to;
        break;
    }

    const query = new URLSearchParams({ from: selectedFrom.toISOString(), to: selectedTo.toISOString() });
    const response = await fetch(`/api/statistics?${query.toString()}`, { Accept: 'application/json' });
    if (response.ok) {
      dispatch(statisticsActions.setItems(await response.json()));
    }
  }

  return (
      <div className={classes.filterWrapper}>
        <FormControl variant="filled" className={classes.neonInput} fullWidth>
          <InputLabel>{t('reportPeriod')}</InputLabel>
        <Select value={period} onChange={(e) => setPeriod(e.target.value)}>
          <MenuItem value="today" className={classes.menuItem}>{t('reportToday')}</MenuItem>
          <MenuItem value="yesterday" className={classes.menuItem}>{t('reportYesterday')}</MenuItem>
          <MenuItem value="thisWeek" className={classes.menuItem}>{t('reportThisWeek')}</MenuItem>
          <MenuItem value="previousWeek" className={classes.menuItem}>{t('reportPreviousWeek')}</MenuItem>
          <MenuItem value="thisMonth" className={classes.menuItem}>{t('reportThisMonth')}</MenuItem>
          <MenuItem value="previousMonth" className={classes.menuItem}>{t('reportPreviousMonth')}</MenuItem>
          <MenuItem value="custom" className={classes.menuItem}>{t('reportCustom')}</MenuItem>
        </Select>
      </FormControl>
      {period === 'custom' && (
        <TextField
            className={classes.neonInput}
            variant="filled"
            label={t('reportFrom')}
            type="datetime-local"
            value={from.format(moment.HTML5_FMT.DATETIME_LOCAL)}
            onChange={e => setFrom(moment(e.target.value, moment.HTML5_FMT.DATETIME_LOCAL))}
            fullWidth
        />
      )}
      {period === 'custom' && (
        <TextField
            className={classes.neonInput}
            variant="filled"
            label={t('reportTo')}
            type="datetime-local"
            value={to.format(moment.HTML5_FMT.DATETIME_LOCAL)}
            onChange={e => setTo(moment(e.target.value, moment.HTML5_FMT.DATETIME_LOCAL))}
            fullWidth
        />
      )}
      <Button
          className={classes.cyberButton}
          onClick={handleClick}
          variant="outlined"
          fullWidth
      >
        {t('reportShow')}
      </Button>
      </div>
  )
}

const StatisticsPage = () => {
  const classes = useStyles();

  const items = useSelector((state) => state.statistics.items);

  return (
      <div className={classes.globalRoot}>
        <CssBaseline />
        <main className={classes.pageContent}>
          <ReportLayoutPage filter={<Filter />}>
            <Container maxWidth="xl">
              <TableContainer className={classes.glassPanel}  component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell className={classes.tableHeader}>{t('statisticsCaptureTime')}</TableCell>
              <TableCell className={classes.tableHeader}>{t('statisticsActiveUsers')}</TableCell>
              <TableCell className={classes.tableHeader}>{t('statisticsActiveDevices')}</TableCell>
              <TableCell className={classes.tableHeader}>{t('statisticsRequests')}</TableCell>
              <TableCell className={classes.tableHeader}>{t('statisticsMessagesReceived')}</TableCell>
              <TableCell className={classes.tableHeader}>{t('statisticsMessagesStored')}</TableCell>
              <TableCell className={classes.tableHeader}>{t('notificatorMail')}</TableCell>
              <TableCell className={classes.tableHeader}>{t('notificatorSms')}</TableCell>
              <TableCell className={classes.tableHeader}>{t('statisticsGeocoder')}</TableCell>
              <TableCell className={classes.tableHeader}>{t('statisticsGeolocation')}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {items.map((item) => (
              <TableRow key={item.id} className={classes.tableRow}>
                <TableCell>{formatDate(item.captureTime)}</TableCell>
                <TableCell>{item.activeUsers}</TableCell>
                <TableCell>{item.activeDevices}</TableCell>
                <TableCell>{item.requests}</TableCell>
                <TableCell>{item.messagesReceived}</TableCell>
                <TableCell>{item.messagesStored}</TableCell>
                <TableCell>{item.mailSent}</TableCell>
                <TableCell>{item.smsSent}</TableCell>
                <TableCell>{item.geocoderRequests}</TableCell>
                <TableCell>{item.geolocationRequests}</TableCell>                           
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
        </Container>
    </ReportLayoutPage>
        </main>
      </div>
  );
}

export default StatisticsPage;
